import { fetchWithOptions } from '../utility/fetch';
import { parseJWTFromCookie } from '../utility/jwtAuthTools';
import { ActionableErrorContext, Loggable, makeLog } from '../utility/logger';

type TGroups = { orgId: string; groupName: string; capabilities: Array<string> };

const fetchGroups = async (): Promise<Array<TGroups>> => {
  try {
    const response = await fetchWithOptions(
      'api/vault/v2/accessgroup',
      { neurojwt: parseJWTFromCookie(), requestorigin: 'neuro-ui' },
      { method: 'GET' },
    );
    if (response.status === 200) return await response.json();
    else throw new Error(`unexpected status: ${response.status}`);
  } catch (error: unknown) {
    let err: Error;
    if (error instanceof Error) {
      err = error;
    } else {
      err = new Error('unexpected status: ' + (<any>error)?.status);
    }
    makeLog(Loggable.BugActionable, err, new ActionableErrorContext(null, 'fetch accessgroups'));
    return [];
  }
};

export const mapGroupsToCapabilities = async (): Promise<IGroupACLMapping> => {
  const groups = await fetchGroups();
  return groups.reduce((acc, g) => ({ ...acc, [g.groupName]: g.capabilities }), {});
};
